import React, { useState, useEffect, useContext, useCallback } from "react";
import { connect } from "react-redux";
import { userActions } from "../_actions/user.actions.js";
import MainContainer from "../Components/MainContainer.js";
import "../style/Home.css";
import "../style/ReportCard.css";
import "../style/Bundles.css";
import { Accordion, Card, Col, Form } from "react-bootstrap";
import {
  getUserLicenseBundleList,
  addUserToDb,
  getBusinessUnits,
  getLicenseBundles,
  getUsersWithAccessToSupportCenter,
} from "../Services/ReportingService.js";
import QuickAddUserModal from "../Components/QuickAddUserModal.js";
import PuffLoader from "react-spinners/PuffLoader";
import { Tooltip } from "react-tooltip";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BundlesList from "../Components/BundlesList.js";
import Notification from "../Components/Notification.js";
import { NotificationsContext } from "../Contexts/NotificationsContext";
import RowCard from "../Components/RowCard.js";
import ALaCarteModal from "../Components/ALaCarteModal.js";
import { formatCurrency } from "../Util/Utils.js";

const Bundles = (props) => {
  const [loading, setLoading] = useState(true);
  const [displayAddUserModal, setDisplayAddUserModal] = useState(false);
  const [isALaCarteModalShowing, setIsALaCarteModalShowing] = useState(false);
  const [businessUnitList, setBusinessUnitList] = useState([]);
  const [businessUnitsForNotHomeOfficeUsers, setBusinessUnitsForNotHomeOfficeUsers] = useState([]);
  const [userBundleLicensesByCompanyLists, setUserBundleLicensesByCompanyLists] = useState([]);
  const [licenseBundles, setLicenseBundles] = useState([]);
  const [licenseBundlesIdToBundle, setLicenseBundlesIdToBundle] = useState(new Map());
  const [licenseBundlesNameToBundle, setLicenseBundlesNameToBundle] = useState(new Map());
  const { addNotification } = useContext(NotificationsContext);
  const [companyToBusinessUnitMap, setCompanyToBusinessUnitMap] = useState(new Map());
  const [allBusinessUnits, setAllBusinessUnits] = useState();
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState();
  const [totalNumberOfBusinessUnits, setTotalNumberOfBusinessUnits] = useState(0);
  const [isShowingAllBusinessUnits, setIsShowingAllBusinessUnits] = useState(false);
  const [bundleTotals, setBundleTotals] = useState({});
  const [defaultOpenAccordionKey, setDefaultOpenAccordionKey] = useState("000");
  const [isHomeOffice, setIsHomeOffice] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState();

  const businessUnit = JSON.parse(sessionStorage.getItem("businessUnit"));
  const userId = sessionStorage.getItem("userId");

  const getAllBusinessUnits = useCallback(async () => {
    const username = sessionStorage.getItem("username");
    const isHomeOffice =
      businessUnit.businessUnitName === "CWM Home Office" ||
      businessUnit.businessUnitName === "City Wide Maintenance (root)";
    setIsHomeOffice(isHomeOffice);

    await getBusinessUnits().then(async (response) => {
      if (response) {
        const newCompanyToBusinessUnitMap = new Map();
        const responseBUs = response.filter((bu) => !bu.businessUnitName.toLowerCase().includes("deprecated"));
        await getUsersWithAccessToSupportCenter().then((response) => {
          const usersThatHaveAccessToSupportCenter = new Set([]);
          response.forEach((user) => {
            usersThatHaveAccessToSupportCenter.add(user.email);
          });

          if (isHomeOffice || usersThatHaveAccessToSupportCenter.has(username)) {
            responseBUs.push({
              businessUnitGuid: null,
              businessUnitName: "Support Center",
              bcCompanyName: "Support Center",
              companyNumber: "Support Center",
              usingBc: null,
            });
          }
        });
        setBusinessUnitList(responseBUs);
        setAllBusinessUnits(responseBUs);
        setTotalNumberOfBusinessUnits(responseBUs.length);
        responseBUs.push({
          businessUnitGuid: null,
          businessUnitName: "Staffing Solutions",
          bcCompanyName: "Staffing Solutions",
          companyNumber: "Staffing Solutions",
          usingBc: null,
        });
        responseBUs.forEach((bu) => {
          newCompanyToBusinessUnitMap.set(bu.bcCompanyName, bu.businessUnitName);
        });
        setCompanyToBusinessUnitMap(newCompanyToBusinessUnitMap);
      }
    });
  }, [businessUnit.businessUnitName]);

  const getBusinessUnitsForNotHomeOfficeUsers = useCallback(() => {
    const newBusinessUnitsForNotHomeOfficeUsers = new Set();
    userBundleLicensesByCompanyLists[0].forEach((user) => {
      if (!newBusinessUnitsForNotHomeOfficeUsers.has(companyToBusinessUnitMap.get(user.companyName))) {
        newBusinessUnitsForNotHomeOfficeUsers.add(companyToBusinessUnitMap.get(user.companyName));
      }
    });
    const businessUnits = Array.from(newBusinessUnitsForNotHomeOfficeUsers).sort();
    setBusinessUnitsForNotHomeOfficeUsers(businessUnits);
    setAllBusinessUnits(businessUnits);
    setTotalNumberOfBusinessUnits(newBusinessUnitsForNotHomeOfficeUsers.size);
  }, [companyToBusinessUnitMap, userBundleLicensesByCompanyLists]);

  const getTotalBundlePrice = useCallback(
    (type) => {
      if (!userBundleLicensesByCompanyLists[0] || licenseBundlesIdToBundle.size === 0) {
        return;
      }

      let totalPrice = 0;

      if (type === "bundles")
        userBundleLicensesByCompanyLists[0].forEach((user) => {
          totalPrice += licenseBundlesIdToBundle.get(user.licenseBundleId).bundlePrice;
        });
      else if (type === "itaas")
        userBundleLicensesByCompanyLists[0].forEach((user) => {
          totalPrice += licenseBundlesIdToBundle.get(user.itaasPackageId).bundlePrice;
        });
      else if (type === "a la carte")
        userBundleLicensesByCompanyLists[0].forEach((user) => {
          totalPrice += licenseBundlesIdToBundle.get(user.asanaPackageId).bundlePrice;
          totalPrice += licenseBundlesIdToBundle.get(user.copilotPackageId).bundlePrice;
          totalPrice += licenseBundlesIdToBundle.get(user.adobeAcrobatProPackageId).bundlePrice;
          totalPrice += licenseBundlesIdToBundle.get(user.teamsPhonePackageId).bundlePrice;
        });

      return totalPrice;
    },
    [licenseBundlesIdToBundle, userBundleLicensesByCompanyLists]
  );

  const fetchUserBundleLicenses = useCallback(() => {
    return getUserLicenseBundleList(userId).then((response) => {
      setUserBundleLicensesByCompanyLists(
        response.filter((bundle) => bundle.bundleName !== "Basic Systems Bundle Only")
      );
    });
  }, [userId]);

  useEffect(() => {
    setLoading(true);

    fetchUserBundleLicenses().then(() => {
      setLoading(false);
    });
  }, [fetchUserBundleLicenses]);

  useEffect(() => {
    setLoading(true);

    getAllBusinessUnits();

    getLicenseBundles().then((response) => {
      if (response) {
        setLicenseBundles(response);

        const bundleIdToBundle = new Map();
        const bundleNameToBundle = new Map();

        response.forEach((bundle) => {
          bundleIdToBundle.set(bundle.bundleId, bundle);
          bundleNameToBundle.set(bundle.bundleName, bundle);
        });

        setLicenseBundlesIdToBundle(bundleIdToBundle);
        setLicenseBundlesNameToBundle(bundleNameToBundle);
        setLoading(false);
      }
    });
  }, [getAllBusinessUnits]);

  const getTotalNumberOfItaasUsers = useCallback(() => {
    if (!userBundleLicensesByCompanyLists[0]) {
      return;
    }

    let noneBundleGuid = licenseBundlesNameToBundle.get("None").bundleId;

    return userBundleLicensesByCompanyLists[0].filter((user) => user.itaasPackageId !== noneBundleGuid).length;
  }, [userBundleLicensesByCompanyLists, licenseBundlesNameToBundle]);

  useEffect(() => {
    if (userBundleLicensesByCompanyLists.length > 0 && companyToBusinessUnitMap.size > 0 && !isHomeOffice) {
      getBusinessUnitsForNotHomeOfficeUsers();
    }
  }, [userBundleLicensesByCompanyLists, companyToBusinessUnitMap, getBusinessUnitsForNotHomeOfficeUsers, isHomeOffice]);

  useEffect(() => {
    if (totalNumberOfBusinessUnits > 0) {
      if (!isHomeOffice && typeof allBusinessUnits[0] !== "string") {
        return;
      }
      if (isHomeOffice && totalNumberOfBusinessUnits > 5) {
        setBusinessUnitList([allBusinessUnits[0]]);
      } else if (!isHomeOffice && totalNumberOfBusinessUnits > 5) {
        setBusinessUnitsForNotHomeOfficeUsers([allBusinessUnits[0]]);
      }
      setSelectedBusinessUnit(allBusinessUnits[0]);
      setDefaultOpenAccordionKey(isHomeOffice ? allBusinessUnits[0].companyNumber : allBusinessUnits[0]);
    }
  }, [totalNumberOfBusinessUnits, allBusinessUnits, isHomeOffice]);

  useEffect(() => {
    if (
      licenseBundles.length > 0 &&
      userBundleLicensesByCompanyLists[0] &&
      userBundleLicensesByCompanyLists[0].length > 0
    ) {
      setBundleTotals({
        bundlesPrice: formatCurrency(getTotalBundlePrice("bundles")),
        itaasBundlesPrice: formatCurrency(getTotalBundlePrice("itaas")),
        numberOfItaasUsers: getTotalNumberOfItaasUsers(),
        numberOfUsers: userBundleLicensesByCompanyLists[0].length.toLocaleString(),
        aLaCartePrice: formatCurrency(getTotalBundlePrice("a la carte")),
      });
    }
  }, [
    licenseBundles,
    licenseBundlesNameToBundle,
    userBundleLicensesByCompanyLists,
    getTotalBundlePrice,
    getTotalNumberOfItaasUsers,
  ]);

  const addUser = async (user) => {
    let newUser = {};
    newUser.CompanyName = user.companyName;
    newUser.DomainName = user.domainName;
    newUser.FullName = user.fullName;
    newUser.LicenseBundleId = licenseBundlesNameToBundle.get(user.bundle).bundleId;
    newUser.ItaasPackageId = licenseBundlesNameToBundle.get(user.itaasBundle).bundleId;
    newUser.AsanaPackageId = licenseBundlesNameToBundle.get(user.asanaBundle).bundleId;
    newUser.CityViewPackageId = licenseBundlesNameToBundle.get("None").bundleId;
    newUser.CopilotPackageId = licenseBundlesNameToBundle.get(user.copilotBundle).bundleId;
    newUser.AdobeAcrobatProPackageId = licenseBundlesNameToBundle.get(user.adobeAcrobatProBundle).bundleId;
    newUser.TeamsPhonePackageId = licenseBundlesNameToBundle.get(user.teamsPhoneBundle).bundleId;

    try {
      await addUserToDb(newUser);
      addNotification({ show: true, type: "Success", description: "User Added Successfully" });
      fetchUserBundleLicenses();
    } catch (error) {
      console.error(error);
      addNotification({
        show: true,
        type: "Error",
        description: (
          <>
            Adding User Failed. Please contact
            <b>itsupport@gocitywide.com</b> for assistance.
          </>
        ),
      });
    }

    setDisplayAddUserModal(false);
  };

  const toggleShowAllBusinessUnits = () => {
    const newIsShowingAllBusinessUnits = !isShowingAllBusinessUnits;
    if (isHomeOffice) {
      if (newIsShowingAllBusinessUnits) {
        setBusinessUnitList(allBusinessUnits);
      } else {
        setBusinessUnitList([selectedBusinessUnit]);
      }
    } else {
      if (newIsShowingAllBusinessUnits) {
        setBusinessUnitsForNotHomeOfficeUsers(allBusinessUnits);
      } else {
        setBusinessUnitsForNotHomeOfficeUsers([selectedBusinessUnit]);
      }
    }
    setIsShowingAllBusinessUnits(newIsShowingAllBusinessUnits);
  };

  const handleSelectBusinessUnitChange = (e) => {
    let selectedBusinessUnit;
    if (isHomeOffice) {
      selectedBusinessUnit = allBusinessUnits.find((bu) => bu.businessUnitName === e.target.value);
      setBusinessUnitList([selectedBusinessUnit]);
    } else {
      selectedBusinessUnit = allBusinessUnits.find((bu) => bu === e.target.value);
      setBusinessUnitsForNotHomeOfficeUsers([selectedBusinessUnit]);
    }
    setSelectedBusinessUnit(selectedBusinessUnit);
    setDefaultOpenAccordionKey(isHomeOffice ? selectedBusinessUnit.companyNumber : selectedBusinessUnit);
  };

  const getTotalPrice = (employee) => {
    const totalPrice =
      licenseBundlesIdToBundle.get(employee.licenseBundleId).bundlePrice +
      licenseBundlesIdToBundle.get(employee.itaasPackageId).bundlePrice +
      licenseBundlesIdToBundle.get(employee.asanaPackageId).bundlePrice +
      licenseBundlesIdToBundle.get(employee.copilotPackageId).bundlePrice +
      licenseBundlesIdToBundle.get(employee.adobeAcrobatProPackageId).bundlePrice +
      licenseBundlesIdToBundle.get(employee.teamsPhonePackageId).bundlePrice;
    return formatCurrency(totalPrice);
  };

  const getALaCartePrice = (employee) => {
    const aLaCartePrice =
      licenseBundlesIdToBundle.get(employee.asanaPackageId).bundlePrice +
      licenseBundlesIdToBundle.get(employee.copilotPackageId).bundlePrice +
      licenseBundlesIdToBundle.get(employee.adobeAcrobatProPackageId).bundlePrice +
      licenseBundlesIdToBundle.get(employee.teamsPhonePackageId).bundlePrice;
    return aLaCartePrice;
  };

  const getALaCartes = (employee) => {
    let aLaCartes = [];

    const noneBundleId = licenseBundlesNameToBundle.get("None").bundleId;

    if (employee.asanaPackageId !== noneBundleId) {
      aLaCartes.push(licenseBundlesIdToBundle.get(employee.asanaPackageId).bundleName);
    }
    if (employee.copilotPackageId !== noneBundleId) {
      aLaCartes.push(licenseBundlesIdToBundle.get(employee.copilotPackageId).bundleName);
    }
    if (employee.adobeAcrobatProPackageId !== noneBundleId) {
      aLaCartes.push(licenseBundlesIdToBundle.get(employee.adobeAcrobatProPackageId).bundleName);
    }
    if (employee.teamsPhonePackageId !== noneBundleId) {
      aLaCartes.push(licenseBundlesIdToBundle.get(employee.teamsPhonePackageId).bundleName);
    }

    if (aLaCartes.length === 0) {
      return "None";
    } else if (aLaCartes.length > 2) {
      return aLaCartes.slice(0, 2).join(", ") + "...";
    } else {
      return aLaCartes.join(", ");
    }
  };

  return (
    <MainContainer>
      <Notification />
      {isHomeOffice && (
        <div className="d-flex flex-row justify-content-between pb-2">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <strong className="page-title" data-testid="bundle-heading">
                Bundles
              </strong>
              <InfoOutlinedIcon
                id="bundleHeaderTooltip"
                sx={{ verticalAlign: "top", margin: "8px", color: "#2d2926" }}
              />
            </div>
            {totalNumberOfBusinessUnits > 5 && (
              <Form.Group style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                {!isShowingAllBusinessUnits && (
                  <Col>
                    <Form.Select
                      as="select"
                      value={
                        isHomeOffice && selectedBusinessUnit
                          ? selectedBusinessUnit.businessUnitName
                          : selectedBusinessUnit
                      }
                      onChange={(e) => handleSelectBusinessUnitChange(e)}
                    >
                      {allBusinessUnits.map((bu) => {
                        return (
                          <option value={isHomeOffice ? bu.businessUnitName : bu}>
                            {isHomeOffice ? bu.businessUnitName : bu}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Col>
                )}
                <Col style={{ marginLeft: "20px" }}>
                  <input
                    type="checkbox"
                    onClick={() => toggleShowAllBusinessUnits()}
                    checked={isShowingAllBusinessUnits}
                    className="showAllBUsCheckbox"
                    id={"showAllBusinessUnits"}
                  />
                  <label for="showAllBusinessUnits" style={{ color: "white" }}>
                    Show All Business Units
                  </label>
                </Col>
              </Form.Group>
            )}
          </div>
          <div className="addUserButton">
            <button
              type="button"
              onClick={() => setDisplayAddUserModal(true)}
              className={`btn btn-dark mx-lg-auto float-right float-lg-none w-100`}
            >
              <FontAwesomeIcon icon={faCheck} /> Add User
            </button>
          </div>
        </div>
      )}
      <Accordion activeKey={defaultOpenAccordionKey} onSelect={(key) => setDefaultOpenAccordionKey(key)}>
        {!loading && (
          <>
            {isHomeOffice && (
              <RowCard
                data={[
                  { label: "Total Users", value: bundleTotals.numberOfUsers },
                  { label: "Total ITaaS Users", value: bundleTotals.numberOfItaasUsers },
                  { label: "Total Bundle Price", value: bundleTotals.bundlesPrice },
                  { label: "Total ITaaS Price", value: bundleTotals.itaasBundlesPrice },
                  { label: "Total A La Carte Price", value: bundleTotals.aLaCartePrice },
                ]}
                mode="stats"
                padding="8px"
              />
            )}
            <Card className="header-card pt-2 pb-2">
              {businessUnit && isHomeOffice && licenseBundles && (
                <>
                  {businessUnitList.map((list) => {
                    return (
                      <BundlesList
                        props={{
                          list,
                          userBundleLicensesByCompanyLists,
                          licenseBundles,
                          isHomeOffice,
                          companyToBusinessUnitMap,
                          setIsALaCarteModalShowing,
                          setSelectedEmployee,
                          getALaCartes,
                          getALaCartePrice,
                          licenseBundlesIdToBundle,
                        }}
                      />
                    );
                  })}
                </>
              )}
              {businessUnit && !isHomeOffice && licenseBundles && (
                <>
                  {businessUnitsForNotHomeOfficeUsers.map((businessUnit, index) => {
                    return (
                      <BundlesList
                        props={{
                          isHomeOffice,
                          businessUnit,
                          userBundleLicensesByCompanyLists,
                          licenseBundles,
                          companyToBusinessUnitMap,
                          isLastList: index === businessUnitsForNotHomeOfficeUsers.length - 1,
                          setIsALaCarteModalShowing,
                          setSelectedEmployee,
                          getALaCartes,
                          getALaCartePrice,
                          licenseBundlesIdToBundle,
                        }}
                      />
                    );
                  })}
                </>
              )}
            </Card>
          </>
        )}
        <div className={`d-flex ${loading ? "" : "d-none"}`}>
          <div className={`mx-auto d-flex`}>
            <PuffLoader size={150} color={"#FFFFFF"} loading={loading} />
          </div>
        </div>
      </Accordion>
      {isHomeOffice && (
        <QuickAddUserModal
          show={displayAddUserModal}
          onHide={() => setDisplayAddUserModal(false)}
          onCancel={() => setDisplayAddUserModal(false)}
          onAdd={(user) => {
            addUser(user);
          }}
          businessUnits={allBusinessUnits}
        />
      )}
      {selectedEmployee && (
        <ALaCarteModal
          show={isALaCarteModalShowing}
          onHide={() => setIsALaCarteModalShowing(false)}
          onCancel={() => setIsALaCarteModalShowing(false)}
          employee={selectedEmployee}
          setEmployee={setSelectedEmployee}
          fetchUserBundleLicenses={fetchUserBundleLicenses}
          getTotalPrice={getTotalPrice}
          licenseBundlesIdToBundle={licenseBundlesIdToBundle}
          licenseBundlesNameToBundle={licenseBundlesNameToBundle}
          readOnly={!isHomeOffice}
        />
      )}
      <Tooltip id="itaasToolTip" anchorSelect="#opsBuildingCountToolTipButton">
        <div>
          <div className="tooltip-heading">
            <p>IT as a Service (ITaaS)</p>
          </div>
          <div className="tooltip-body">
            <p>
              City Wide IT as a Service enables your franchise to utilize the Support Center for your Office 365
              subscriptions and other IT support needs.
            </p>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">None: </p>
              Regular support level and licensing for CWCMS systems.
            </li>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Standard: </p>
              Includes Office 365 subscription on the GoCityWide domain.
            </li>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Premium: </p>
              Includes Office 365 subscription plus complete IT support needs for your office.
            </li>
            <p className="tooltip-footer">Contact ITSupport@GoCityWide.com for more information.</p>
          </div>
        </div>
      </Tooltip>
      <Tooltip id="bundleHeaderTooltip" anchorSelect="#bundleHeaderTooltip">
        <div>
          <div className="tooltip-body">
            <p>
              Choose the most appropriate license bundle, based on the user's role. See below for the available license
              bundles.
            </p>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Accounting: </p>
              Controllers, accounting staff, and anyone who enters data into BC.
            </li>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Operations: </p>
              FSM, DOO, and ops users other than Night Managers.
            </li>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Sales: </p>
              Sales Executives and sales management, BDS, and Sales Associates.
            </li>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Executive: </p>
              Franchise owners and general managers who are not performing accounting, ops, or sales roles (if the owner
              or GM is acting as an accounting, ops, or sales role, then select the most appropriate bundle for the role
              the user is performing).
            </li>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Email Only: </p>
              Users or Distribution Lists (DL) that have email but no need for any other system access.
            </li>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Night Manager: </p>
              As you might guess, this is good for Night Managers.
            </li>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Administrative User: </p>
              CRM but not BC users. This might be an IC recruiter or other person requiring CRM access who is not an
              accounting user.
            </li>
          </div>
        </div>
      </Tooltip>
    </MainContainer>
  );
};

function mapStateToProps(state) {
  const { authentication } = state;
  const { crmUser } = authentication;
  return { crmUser };
}

const actionCreators = {
  logout: userActions.logout,
  changePage: userActions.changePage,
};

const connectedBundlesPage = connect(mapStateToProps, actionCreators)(Bundles);
export { connectedBundlesPage as Bundles };
